import {useState} from "react";

function DataBlockLabel({text, tooltip, criticalMessage = null}) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    return (
        <>
        <div className="flex items-center">
            <p className="text-sm lg:text-lg lg:font-semibold">{text}</p>
            {tooltip && (
                <div
                    className="bg-olaf-orange-500 w-5 h-5 ml-2 flex justify-center items-center rounded-full cursor-pointer"
                    onClick={() =>
                        tooltipOpen ? setTooltipOpen(false) : setTooltipOpen(true)
                    }
                >
                    <span className="text-xs text-white font-bold">i</span>
                </div>
            )}
            {tooltip && (
                <div
                    className={`z-50 fixed top-0 left-0 w-full h-full px-[4%] lg:px-0 justify-center items-center ${
                        tooltipOpen ? "flex" : "hidden"
                    }`}
                >
                    <div className="absolute top-0 left-0 w-full h-full bg-black/30"></div>
                    <div className="relative olafGrid bg-white px-4 py-5 rounded-tl-lg rounded-br-lg !max-w-md">
                        <h2 className="text-sm lg:text-base">
                            {text}
                            <div
                                className="absolute top-4 right-[4%] w-6 h-6 cursor-pointer"
                                onClick={() => setTooltipOpen(false)}
                            >
                                <div
                                    className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 rotate-45 rounded-[1px]"></div>
                                <div
                                    className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 -rotate-45 rounded-[1px]"></div>
                            </div>
                        </h2>
                        <p className="text-sm lg:text-base">{tooltip}</p>
                    </div>
                </div>
            )}
        </div>
            {criticalMessage && <span className="text-md text-olaf-red-100">{criticalMessage}</span>}
            {criticalMessage && <span className="text-md text-olaf-red-100">{criticalMessage}</span>}

        </>
    );
}

export default DataBlockLabel;
